import {useEffect, useState} from "react";
import {Button, Col, ConfigProvider, Form, Input, message, Row, Select} from "antd";


import styles from '../index.module.less'
import {SFuncModal} from "shj-components";
import {controlPanelSendUpdatePhoneCode, controlPanelUpdatePhone} from "@/services";

interface IProps {
  onClose: (data?: string) => void
}

const EditPhoneForm = (props: IProps) => {
  const {onClose} = props;
  let [form] = Form.useForm();

  const [isGetting, setIsGetting] = useState<boolean>(false)
  const [sendCodeLoading, setSendCodeLoading] = useState<boolean>(false)
  const [waitingTime, setWaitingTime] = useState<number>(60)

  useEffect(() => {
    form.resetFields();
  }, []);


  useEffect(() => {
    if (isGetting) {
      const timer = setTimeout(() => {
        if (waitingTime > 0) {
          setWaitingTime(waitingTime - 1)
        } else {
          setIsGetting(false)
        }
        clearTimeout(timer)
      }, 1000)
    } else {
      setWaitingTime(60)
    }
  }, [isGetting, waitingTime])


  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select defaultValue={'86'} style={{width: 100}}>
        <Select.Option value="86">+86</Select.Option>
      </Select>
    </Form.Item>
  );

  const onGetCheckCode = () => {
    form.validateFields(['phone']).then(() => {
      setSendCodeLoading(true);
      controlPanelSendUpdatePhoneCode({phone: form.getFieldValue('phone')})
        .then(() => {
          setIsGetting(true);
          setSendCodeLoading(false);
        })
        .catch(() => {
          setIsGetting(false);
          setSendCodeLoading(false);
        })
    })
  }

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      form
        .validateFields()
        .then((values) => {
          controlPanelUpdatePhone(values).then(() => {
            message.success('操作成功')
            resolve();
            onClose(values.phone)
          })
        })
        .catch(reject);
    });
  };

  return (
    <SFuncModal.Content
      okText={'保存'}
      onOk={onFinish}
      onCancel={() => onClose()}
      confirmLoading={false}
    >
      <Form form={form} layout={'vertical'}>

        <Form.Item label={'新手机号'} name={'phone'}
               rules={[{required: true, message: '手机号不能为空'}, {
                 pattern: /^1[\d]{10}/,
                 message: '请输入正确格式的手机号'
               }]}
        >
          <Input placeholder={'请输入新手机号'} maxLength={11} minLength={11} addonBefore={prefixSelector}
               style={{width: '100%'}}/>
        </Form.Item>
        <Row>
          <Col span={18}>
            <Form.Item
              name="code"
              label={'验证码'}
              className={styles.mb_0}
              rules={[{required: true, message: '验证码不能为空'}]}
            >
              <Input style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}
                   placeholder="请输入验证码"/>
            </Form.Item>
          </Col>
          <Col span={6}>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    defaultBg: '#fafafa',
                    defaultActiveBg: '#fafafa',
                    defaultHoverBg: '#fafafa',
                    defaultActiveBorderColor: '#d9d9d9',
                    defaultHoverBorderColor: '#d9d9d9',
                    defaultActiveColor: '#000000e0',
                    defaultHoverColor: '#000000e0',
                  },
                },
              }}
            >
              <Button
                className={styles.right_code_btn}
                block
                onClick={onGetCheckCode}
                disabled={isGetting}
                loading={sendCodeLoading}
              >
                {!isGetting ? '获取验证码' : `${waitingTime} s`}
              </Button>
            </ConfigProvider>
          </Col>
        </Row>
      </Form>
    </SFuncModal.Content>);
};

export default EditPhoneForm
